import React from 'react';
import { withRouter } from 'react-router-dom';
import Modal from '../../../app/modal/v2';
import CollectionOnboardCarousel from '../carousel';
import {
  SlideOne, SlideTwo, SlideThree, SlideFour,
} from './slides';
import historyShape from '../../../app/shapes/history';

const ChildOnboard = ({ history: { push } }) => (
  <Modal
    fullscreenMobile
    closeButton
    // onClose={() => push('/collections/new')}
    onClose={() => push('/collections')}
  >
    <CollectionOnboardCarousel
      ctaText="Start a Child Journal"
      onClose={() => push('/child-journals/new')}
    >
      <SlideOne />
      <SlideTwo />
      <SlideThree />
      <SlideFour />
    </CollectionOnboardCarousel>
  </Modal>
);

ChildOnboard.propTypes = {
  history: historyShape.isRequired,
};

export default withRouter(ChildOnboard);
